import * as React from 'react';

function SvgViewTerms(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#FCCE01" d="M6.472 5.912H21.21v16.58H6.472z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.889 2.7c.562 0 1.02.507 1.02 1.134V9.71c0 .416.342.752.764.752a.758.758 0 00.764-.752V3.267c0-1.252-.912-2.267-2.04-2.267H3.6C2.472 1 1.56 2.015 1.56 3.267v17.57c0 1.253.912 2.268 2.04 2.268h6.998c.23 0 .449-.09.61-.249a.84.84 0 00.251-.6.863.863 0 00-.87-.851h-6.48c-.564 0-1.02-.507-1.02-1.134V3.834c0-.627.458-1.133 1.02-1.133h15.78zm-4.092 3.045H5.864v.001a.956.956 0 00-.964.948v.15c0 .523.432.947.964.947h9.933c.255 0 .5-.1.681-.277a.94.94 0 00.282-.67v-.152a.94.94 0 00-.282-.67.972.972 0 00-.681-.277zm-9.86 3.957h5.037a1.03 1.03 0 011.037 1.02v.003a1.03 1.03 0 01-1.037 1.021H5.938c-.276 0-.54-.107-.734-.299a1.011 1.011 0 01-.304-.722v-.003c0-.564.466-1.02 1.038-1.02zm1.697 3.955H5.7c-.573 0-1.037.456-1.037 1.02v.003c0 .27.108.53.303.722.194.192.459.3.734.3h1.934A1.03 1.03 0 008.67 14.68v-.003c0-.564-.464-1.02-1.037-1.02zm7.2 7.75h6.74c.476 0 .863.38.863.849s-.387.85-.864.85h-6.74a.857.857 0 01-.864-.85c0-.47.387-.85.864-.85zm.59-9.427a2.15 2.15 0 103.041 3.04 2.15 2.15 0 00-3.04-3.04zm-1.202 4.242a3.85 3.85 0 116.06-.8l2.32 2.32a1 1 0 11-1.415 1.415l-2.32-2.32a3.852 3.852 0 01-4.645-.615z"
        fill="#595959"
      />
    </svg>
  );
}

export default SvgViewTerms;
